import { Validators } from "@angular/forms";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
} from "@hardcode-kz/ui";
import { IMeasurementUnit } from "@app/shared/data-access/src/lib/resource-management/models/measurement-unit";
import { ResourceManagementEndpoints } from "@dmms/shared/data-access/resource-management/types/resource-management-endpoints";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";

export class MeasurementUnitConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.MeasurementUnit;
  title = "Единицы измерения";
  isCrudByModal = true;

  fields: IHardFormField[] = [
    {
      name: "displayName",
      title: "dicTable.name",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "code",
      title: "base.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "sortOrder",
      title: "dicTable.sortOrder",
      type: HardFormFieldTypeEnum.Number,
      params: {
        validators: [Validators.required],
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IMeasurementUnit[]> = {
    showDefaultActions: true,
    tableColumns: "40px 1fr 1fr auto",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        name: "displayName",
        title: "dicTable.name",
        type: HardTableColumnTypeEnum.Text,
      },
      {
        name: "code",
        title: "base.code",
        type: HardTableColumnTypeEnum.Text,
      },
    ],
  };
}
